import gsap from 'gsap'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

import useMediaQuery from '../../../hooks/useMediaQuery'
import { desktopMenuWrapperTop$ } from '../../../lib/header/parallax'
import { StyledFunctionComponent } from '../../types'
import { DesktopMainMenu } from './DesktopMainMenu'
import { DesktopUtilityMenu } from './DesktopUtilityMenu'

const DesktopMenuWrapper: StyledFunctionComponent = ({ className }) => {
  const innerDivRef = useRef<HTMLDivElement>(null)
  const isNarrow = useMediaQuery({ maxWidth: '991px' })

  useEffect(() => {
    const subscription = desktopMenuWrapperTop$.subscribe((desktopMenuWrapperTop) => {
      if (innerDivRef.current) {
        gsap.set(innerDivRef.current, { top: desktopMenuWrapperTop })
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  return (
    <div className={className} ref={innerDivRef}>
      {!isNarrow && (
        <>
          <DesktopUtilityMenu />
          <DesktopMainMenu />
        </>
      )}
    </div>
  )
}

const StyledDesktopMenuWrapper = styled(DesktopMenuWrapper)`
  display: none;
  position: relative;

  @media (min-width: 992px) {
    display: block;
  }
  @media print {
    display: none;
  }
`

export default StyledDesktopMenuWrapper
